import React, { useState, useEffect } from "react"
import LoginPage from "./pages/LoginPage"
import Dashboard from "./pages/Dashboard"
import { Toaster } from "react-hot-toast"
import { GuiasProvider } from "./context/GuiasContext"
import AutoDownloadGuia from "./components/AutoDownloadGuia"

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userRole, setUserRole] = useState<"admin" | "user">("user")
  const [userName, setUserName] = useState<string>("")

  // Verificar se tem parâmetro guia na URL para auto-download
  const [isDownloadMode, setIsDownloadMode] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get("guia")) {
      setIsDownloadMode(true)
    }
  }, [])

  const handleLogin = (role: "admin" | "user", nomeCompleto: string) => {
    setIsAuthenticated(true)
    setUserRole(role)
    setUserName(nomeCompleto)
  }

  const handleLogout = () => {
    setIsAuthenticated(false)
  }

  return (
    <GuiasProvider>
      <Toaster position="top-right" />
      {isDownloadMode ? (
        <div className="min-h-screen bg-gradient-to-br from-[#004161] to-[#006b8f] flex items-center justify-center">
          <div className="bg-white p-8 rounded-xl shadow-2xl text-center max-w-md">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#004161] mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Preparando Download</h2>
            <p className="text-gray-600">Aguarde enquanto geramos o PDF da guia...</p>
          </div>
          <AutoDownloadGuia />
        </div>
      ) : !isAuthenticated ? (
        <LoginPage onLogin={handleLogin} />
      ) : (
        <Dashboard userRole={userRole} userName={userName} onLogout={handleLogout} />
      )}
    </GuiasProvider>
  )
}

export default App
